import { combineReducers } from 'redux';
import { NAME as roomingListKey, reducer as roomingListReducer } from './ducks/roomingList';
import { NAME as tasksKey, reducer as tasksReducer } from './ducks/tasks';
import {
    reservationModuleStateKey,
    reservationModuleStateReducer,
    summaryKey,
    summaryReducer,
    balancesKey,
    balancesReducer,
} from './reducers';

export { NAME as MODULE_NAME } from './module';
export * from './constants';
export { changeTab, toggleReservationChecked, setReservationsChecked } from './actions';
export {
    getCheckedReservationIds,
    isReservationChecked,
    isAnyReservationByIdsChecked,
    areAllReservationByIdsChecked,
} from './selectors';

export { CHANGE_TAB } from './actionTypes';
export { ReservationDetailContainer } from './components/ReservationModule/initialize';
export { default as StateTab } from './components/StateTab';
export { MailingTab } from './components/MailingTab';
export { default as ItemsTab } from './components/ItemsTab';
export { default as SummaryTab } from './components/Summary';
export { PricingTab } from './components/PricingSection';
export { default as PropertiesTab } from './components/PropertiesTab';
export { GroupTab } from './components/GroupTab';
export { default as ReservationActionLog } from './components/ActionLog/ReservationsActionLog';

export const reducer = combineReducers({
    [reservationModuleStateKey]: reservationModuleStateReducer,
    [roomingListKey]: roomingListReducer,
    [summaryKey]: summaryReducer,
    [tasksKey]: tasksReducer,
    [balancesKey]: balancesReducer,
});
